import React from 'react';
import { gettext } from '@eventbrite/i18n';
import { Typography, Button } from '@eventbrite/marmalade';

import styles from './SalesBlock.module.scss';

export const SalesBlock = () => {
    return (
        <div className={styles.sales_block}>
            <div className={styles.title_section}>
                <Typography variant="heading-lg" className={styles.title}>
                    {gettext('Hosting large events?')}
                </Typography>
                <Typography variant="body-lg" className={styles.description}>
                    {gettext(
                        'Grow your events with our expert team by your side',
                    )}
                </Typography>
            </div>

            <div className={styles.sales_cards}>
                <div className={styles.sales_card}>
                    <img src="https://eventbrite-s3.s3.us-east-1.amazonaws.com/marketing/landingpages/assets/2025/rebrand/organizer/pricing/High+Five.svg" />
                    <Typography
                        variant="body-md"
                        className={styles.card_description}
                    >
                        {gettext(
                            'Unlock winning strategies with a Strategic Advisor',
                        )}
                    </Typography>
                </div>
                <div className={styles.sales_card}>
                    <img src="https://eventbrite-s3.s3.us-east-1.amazonaws.com/marketing/landingpages/assets/2025/rebrand/organizer/pricing/Tickets.svg" />
                    <Typography
                        variant="body-md"
                        className={styles.card_description}
                    >
                        {gettext(
                            'Expand your reach with exclusive Eventbrite-sponsored marketing',
                        )}
                    </Typography>
                </div>
                <div className={styles.sales_card}>
                    <img src="https://eventbrite-s3.s3.us-east-1.amazonaws.com/marketing/landingpages/assets/2025/rebrand/organizer/pricing/Chat.svg" />
                    <Typography
                        variant="body-md"
                        className={styles.card_description}
                    >
                        {gettext(
                            'Get priority access to phone and 24/7 chat support',
                        )}
                    </Typography>
                </div>
            </div>

            <Button
                onClick={() => {
                    window.location.href = '/l/contact-eventbrite-sales/';
                }}
                variant="primary"
                size="responsive"
                className={styles.sales_cta}
            >
                {gettext('Reach out to us')}
            </Button>
        </div>
    );
};

export default SalesBlock;
